import { PollingConfig } from '../types/polling';

export const POLLING_CONFIGS = {
  DOCUMENT_STATUS: {
    interval: 6000,
    enabled: true,
    maxRetries: 5,
    retryDelay: 1000,
    maxAttempts: 10,
  } as PollingConfig,
  
  FAST_POLLING: {
    interval: 1000,
    enabled: true,
    maxRetries: 5,
    retryDelay: 500,
    maxAttempts: 10,
  } as PollingConfig,
  
  SLOW_POLLING: {
    interval: 10000,
    enabled: true,
    maxRetries: 2,
    retryDelay: 2000,
    maxAttempts: 5,
  } as PollingConfig,
} as const;
